import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import {
  setShopHomeCms,
  saveThemeJsonData,
  fetchCroppedImage,
} from "../../../../redux/Actions";
import { useSelector } from "react-redux";
import ImageCropper from "../../../imageCropper/imageCropper";

function SectionFourThemeFiveEdit() {
  const [checklist, setChecklist] = useState<any>([
    { id: 1, title: "" }, // Initial empty checklist item
  ]);
  const dispatch = useDispatch<any>();
  const [editData, setEditData] = useState<any>();
  const jsonData: any = useSelector<any>((state) => state.shopHomeJsonList);
  const [activeTab, setActiveTab] = useState(0);
  const [cropImageHeight, setCropImageHeight] = useState("");
  const [cropImageWidth, setCropImageWidth] = useState("");
  const [selectedCropImage, setSelectedCropImage] = useState("");
  const [imageName, setImageName] = useState("");
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>("" || undefined);
  const banner_one = [
    "assets//img/offer/offer-vector-bg.png",
    "assets//img/offer/offer-vector-bg.png",
    "assets//img/offer/offer-vector-bg.png",
    "assets//img/offer/offer-vector-bg.png",
    "assets//img/offer/offer-vector-bg.png",
    "assets//img/offer/offer-vector-bg.png",
    "assets//img/offer/offer-vector-bg.png",
  ];
  const banner_two = [
    "assets/img/offer/offer-tag.png",
    "assets/img/offer/offer-tag.png",
    "assets/img/offer/offer-tag.png",
    "assets/img/offer/offer-tag.png",
    "assets/img/offer/offer-tag.png",
    "assets/img/offer/offer-tag.png",
    "assets/img/offer/offer-tag.png",
  ];
  const banner_three = [
    "assets/img/offer/offer-wash-img.png",
    "assets/img/offer/offer-wash-img.png",
    "assets/img/offer/offer-wash-img.png",
    "assets/img/offer/offer-wash-img.png",
    "assets/img/offer/offer-wash-img.png",
    "assets/img/offer/offer-wash-img.png",
    "assets/img/offer/offer-wash-img.png",
  ];

  const saveJsonDataToFile = () => {
    dispatch(setShopHomeCms(editData));
    dispatch(saveThemeJsonData(editData));
  };
  const handleSection2Change = (e: any) => {
    const { value, name, type, checked } = e.target;
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        ...prevJsonData.theme_5,

        home: {
          ...prevJsonData.theme_5.home,
          section_4: {
            ...prevJsonData.theme_5.home.section_4,
            [name]: value,
            paragraph_one:
              name === "option_one"
                ? value
                : prevJsonData.theme_5.home.section_8.paragraph_one,
          },
        },
      },
    }));
    // saveJsonDataToFile();
  };
  const handleImageChange = (image: string, name: any) => {
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        home: {
          ...prevJsonData.theme_5.home,
          section_4: {
            ...prevJsonData.theme_5.home.section_4,
            [name]: image,
          },
        },
      },
    }));
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await dispatch(fetchCroppedImage(image));
    if (imageLink != false) {
      handleImageChange(imageLink, imageName);
    }
  };

  const updateImageSectionOne = async (e: any, name: any) => {
    const image = e.target.files[0];
    // setImageName(name);
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  useEffect(() => {
    const checklistData = editData?.theme_5?.home?.section_4?.check_list;
    if (checklistData) {
      setChecklist(checklistData);
    }
  }, [editData]);
  useEffect(() => {
    setEditData(jsonData);
  }, [jsonData]);
  useEffect(() => {
    if (editData != undefined) {
      // dispatch(setShopHomeCms(editData));
      setEditData(editData);
    }
  }, [editData]);
  return (
    <>
      {/* <Draggable> */}
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section 4 Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="edit-section">
                      <div className="row">
                        <div className="col">
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="img-bg active">
                                  <img
                                    src={
                                      editData?.theme_5?.home?.section_4?.banner
                                    }
                                    alt={`Card Icon`}
                                  />
                                </div>
                                <div className="img-options w-100">
                                  <Swiper
                                    spaceBetween={15}
                                    navigation={true}
                                    modules={[Navigation]}
                                    breakpoints={{
                                      640: {
                                        slidesPerView: 1,
                                      },
                                      768: {
                                        slidesPerView: 4,
                                      },
                                      1024: {
                                        slidesPerView: 6,
                                      },
                                    }}
                                    className="homejson-slider"
                                  >
                                    {banner_one.map((icons, iconIndex) => (
                                      <SwiperSlide key={iconIndex}>
                                        <div
                                          className="img-option"
                                          onClick={() =>
                                            handleImageChange(icons, "banner")
                                          }
                                        >
                                          <img
                                            src={icons}
                                            alt="Hero Image"
                                            className="img-fluid"
                                          />
                                        </div>
                                      </SwiperSlide>
                                    ))}
                                  </Swiper>
                                </div>
                                {/* </>
                                  )
                                )} */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Upload Image</label>
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        className="form-control"
                        name="image"
                        onChange={(e) => {
                          updateImageSectionOne(e, "banner");
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="edit-section">
                      <div className="row">
                        <div className="col">
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="img-bg active">
                                  <img
                                    src={
                                      editData?.theme_5?.home?.section_4
                                        ?.offer_tag
                                    }
                                    alt={`Card Icon`}
                                  />
                                </div>
                                <div className="img-options w-100">
                                  <Swiper
                                    spaceBetween={15}
                                    navigation={true}
                                    modules={[Navigation]}
                                    breakpoints={{
                                      640: {
                                        slidesPerView: 1,
                                      },
                                      768: {
                                        slidesPerView: 4,
                                      },
                                      1024: {
                                        slidesPerView: 6,
                                      },
                                    }}
                                    className="homejson-slider"
                                  >
                                    {banner_two.map((icons, iconIndex) => (
                                      <SwiperSlide key={iconIndex}>
                                        <div
                                          className="img-option"
                                          onClick={() =>
                                            handleImageChange(
                                              icons,
                                              "offer_tag"
                                            )
                                          }
                                        >
                                          <img
                                            src={icons}
                                            alt="Hero Image"
                                            className="img-fluid"
                                          />
                                        </div>
                                      </SwiperSlide>
                                    ))}
                                  </Swiper>
                                </div>
                                {/* </>
                                  )
                                )} */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Upload Image</label>
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        className="form-control"
                        name="image"
                        onChange={(e) => {
                          updateImageSectionOne(e, "offer_tag");
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="edit-section">
                      <div className="row">
                        <div className="col">
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="img-bg active">
                                  <img
                                    src={
                                      editData?.theme_5?.home?.section_4
                                        ?.picture
                                    }
                                    alt={`Card Icon`}
                                  />
                                </div>
                                <div className="img-options w-100">
                                  <Swiper
                                    spaceBetween={15}
                                    navigation={true}
                                    modules={[Navigation]}
                                    breakpoints={{
                                      640: {
                                        slidesPerView: 1,
                                      },
                                      768: {
                                        slidesPerView: 4,
                                      },
                                      1024: {
                                        slidesPerView: 6,
                                      },
                                    }}
                                    className="homejson-slider"
                                  >
                                    {banner_three.map((icons, iconIndex) => (
                                      <SwiperSlide key={iconIndex}>
                                        <div
                                          className="img-option"
                                          onClick={() =>
                                            handleImageChange(icons, "picture")
                                          }
                                        >
                                          <img
                                            src={icons}
                                            alt="Hero Image"
                                            className="img-fluid"
                                          />
                                        </div>
                                      </SwiperSlide>
                                    ))}
                                  </Swiper>
                                </div>
                                {/* </>
                                  )
                                )} */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Upload Image</label>
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        className="form-control"
                        name="image"
                        onChange={(e) => {
                          updateImageSectionOne(e, "picture");
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Paragraph</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="option_one"
                        value={
                          editData?.theme_5?.home?.section_4?.paragraph_one
                        }
                        onChange={handleSection2Change}
                        maxLength={1200}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonDataToFile();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* </Draggable> */}
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: "block" }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
}

export default SectionFourThemeFiveEdit;
